/**
 * Página de DATOS ABIERTOS / API — el "contrato" público para que otras apps se
 * conecten. Estática (sin datos por request) → se prerenderiza y precachea.
 */
export const prerender = true;
